// extracted by mini-css-extract-plugin
export default {"beerlist":"style_beerlist__k9NWd","title":"style_title__P2bt6","beerlistcard":"style_beerlistcard__yFBcB","card":"style_card__Op-KA"};